import { z } from 'zod';
// ---------------------------------------------------------------------------
// Shared taxonomy (SPEC §1.7) + priority/assignee enums.
//
// Defined once here and imported by both web and api. The Prisma schema mirrors
// these exact string values in its native Postgres enums — keep the two in sync.
// ---------------------------------------------------------------------------
/** Category applied to every list item and map marker (SPEC §1.7). */
export const CATEGORIES = [
    'hike',
    'sight',
    'route',
    'town',
    'food',
    'stay',
    'activity',
    'culture',
    'event',
    'other',
];
export const categorySchema = z.enum(CATEGORIES);
/** Display metadata per category — colour + icon for badges and the map legend. */
export const CATEGORY_META = {
    hike: { label: 'Hike', color: '#16a34a', icon: '🥾' },
    sight: { label: 'Sight', color: '#0ea5e9', icon: '📍' },
    route: { label: 'Route', color: '#f59e0b', icon: '🛣️' },
    town: { label: 'Town', color: '#8b5cf6', icon: '🏘️' },
    food: { label: 'Food', color: '#ef4444', icon: '🍽️' },
    stay: { label: 'Stay', color: '#0d9488', icon: '🛏️' },
    activity: { label: 'Activity', color: '#db2777', icon: '🧗' },
    culture: { label: 'Culture', color: '#a16207', icon: '🏛️' },
    event: { label: 'Event', color: '#7c3aed', icon: '🎉' },
    other: { label: 'Other', color: '#94a3b8', icon: '•' },
};
/** MoSCoW priority column. */
export const PRIORITIES = ['must', 'should', 'could'];
export const prioritySchema = z.enum(PRIORITIES);
/** The two fixed account usernames (SPEC §3.1). */
export const USERNAMES = ['joel', 'lea'];
export const usernameSchema = z.enum(USERNAMES);
/**
 * Assignee as used in forms/UI: a list item is assigned to Joel, Lea, or both.
 * `both` maps to a null `assigneeId` in the data model (SPEC §3.4).
 */
export const ASSIGNEES = ['joel', 'lea', 'both'];
export const assigneeSchema = z.enum(ASSIGNEES);
//# sourceMappingURL=enums.js.map